module.exports = __webpack_public_path__ + "img/scheduling.6ff5479f.svg";